module.exports = __webpack_public_path__ + "static/media/donation.20085cb1.svg";